
import { defineMessages } from "react-intl";

export default defineMessages({
  //  Events
  Text_Event_NoTransmission: {
    id: "Text-Event-NoTransmission",
    defaultMessage: "No Transmission",
  },
  Text_Event_SensorDisconnected: {
    id: "Text-Event-SensorDisconnected",
    defaultMessage: "Sensor Disconnected",
  },
  Text_Event_ReplaceSensor: {
    id: "Text-Event-ReplaceSensor",
    defaultMessage: "Replace Sensor",
  },
  Text_Event_SensorDamaged: {
    id: "Text-Event-SensorDamaged",
    defaultMessage: "SensorModule Defective",
  },
  Text_Event_SensorUpgrade: {
    id: "Text-Event-SensorUpgrade",
    defaultMessage: "Sensor Upgrade",
  },
  Text_Event_OnBed: {
    id: "Text-Event-OnBed",
    defaultMessage: "On Bed",
  },
  Text_Event_NotOnBed: {
    id: "Text-Event-NotOnBed",
    defaultMessage: "Not on Bed",
  },
  Text_Event_Stirring: {
    id: "Text-Event-Stirring",
    defaultMessage: "Stirring",
  },
  Text_Event_SittingUp: {
    id: "Text-Event-SittingUp",
    defaultMessage: "Sitting Up",
  },
  Text_Event_Leaving: {
    id: "Text-Event-Leaving",
    defaultMessage: "Leaving",
  },
  Text_Event_OutofBed: {
    id: "Text-Event-OutofBed",
    defaultMessage: "Out of Bed",
  },
  Text_Event_Return: {
    id: "Text-Event-Return",
    defaultMessage: "Return",
  },
  Text_Event_Reposition: {
    id: "Text-Event-Reposition",
    defaultMessage: "Reposition",
  },
  Text_Event_Immobile: {
    id: "Text-Event-Immobile",
    defaultMessage: "Immobile",
  },
  Text_Event_Wandering: {
    id: "Text-Event-Wandering",
    defaultMessage: "Wandering",
  },
  Text_Event_NurseModeOn: {
    id: "Text-Event-NurseModeOn",
    defaultMessage: "Nurse Mode",
  },
  Text_Event_NurseModeResponse: {
    id: "Text-Event-NurseModeResponse",
    defaultMessage: "Nurse Response",
  },
  // User Login
  Text_UserLogin_ID: {
    id: "Text-UserLogin-ID",
    defaultMessage: "Account",
  },
  Text_UserLogin_PWD: {
    id: "Text-UserLogin-PWD",
    defaultMessage: "Password",
  },
  Text_UserLogin_ID_Required: {
    id: "Text-UserLogin-ID-Required",
    defaultMessage: "Account is required",
  },
  Text_UserLogin_PWD_Required: {
    id: "Text-UserLogin-PWD-Required",
    defaultMessage: "Password is required",
  },
  Text_Button_Login: {
    id: "Text-Button-Login",
    defaultMessage: "Login",
  },
  Text_CareUnitSelection_Title: {
    id: "Text-CareUnitSelection-Title",
    defaultMessage: "Select a care unit",
  },
  // system function menu
  Text_Function_User_Manager: {
    id: "Text-Function-User-Manager",
    defaultMessage: "User Accounts",
  },
  Text_Function_Box_Manager: {
    id: "Text-Function-Box-Manager",
    defaultMessage: "Box Management",
  },
  Text_Function_BoxDispatch: {
    id: "Text-Function-BoxDispatch",
    defaultMessage: "Box Dispatch",
  },
  Text_Function_BoxPairing: {
    id: "Text-Function-BoxPairing",
    defaultMessage: "Box Pairing",
  },
  Text_Function_BoxWiFi: {
    id: "Text-Function-BoxWiFi",
    defaultMessage: "Box WiFi",
  },
  Text_Function_UserSettings: {
    id: "Text-Function-UserSettings",
    defaultMessage: "Change Password",
  },
  Text_Function_UserLogout: {
    id: "Text-Function-UserLogout",
    defaultMessage: "User Logout",
  },
  Text_Function_About: {
    id: "Text-Function-About",
    defaultMessage: "About",
  },
  Text_Function_Language: {
    id: "Text-Function-Language",
    defaultMessage: "Language",
  },
  Text_Function_Patient_CheckIn: {
    id: "Text-Function-Patient-CheckIn",
    defaultMessage: "Patient CheckIn",
  },
  Text_Function_Patient_Settings: {
    id: "Text-Function-Patient-Settings",
    defaultMessage: "Patient Settings",
  },
  Text_Function_Patient_Transfer: {
    id: "Text-Function-Patient-Transfer",
    defaultMessage: "Patient Transfer",
  },
  Text_Function_Patient_CheckOut: {
    id: "Text-Function-Patient-CheckOut",
    defaultMessage: "Patient CheckOut",
  },

  Text_TopBar_GoMainPage: {
    id: "Text-TopBar-GoMainPage",
    defaultMessage: "Go main page",
  },
  // SideBar-Notification
  Text_Notification: {
    id: "Text-Notification",
    defaultMessage: "Notification List",
  },
  Text_SideBar_SortByBedId: {
    id: "Text-SideBar-SortByBedId",
    defaultMessage: "Sort By Bed ID",
  },
  Text_SideBar_SortByEventTime: {
    id: "Text-SideBar-SortByEventTime",
    defaultMessage: "Sort By Time",
  },
  Text_SideBar_SortByEventType: {
    id: "Text-SideBar-SortByEventType",
    defaultMessage: "Sort By Type",
  },
  Text_SideBar_NoNotification: {
    id: "Text-SideBar-NoNotification",
    defaultMessage: "No notification",
  },
  Text_SideBar_NoNotificationHint: {
    id: "Text-SideBar-NoNotificationHint",
    defaultMessage: "A notification will appear once an alert is triggered.",
  },
  Text_SideBar_ChangeCareUnitHint: {
    id: "Text-SideBar-ChangeCareUnitHint",
    defaultMessage: "To switch the care unit and return to the main page?",
  },

  // Main Page
  Text_MainPage_Search: {
    id: "Text-MainPage-Search",
    defaultMessage: "Patient ID or Bed No",
  },
  Text_MainPage_PressurePoint: {
    id: "Text-MainPage-PressurePoint",
    defaultMessage: "Pressure Point",
  },
  Text_MainPage_SortBy: {
    id: "Text-MainPage-SortBy",
    defaultMessage: "Sort By",
  },
  Text_MainPage_SortByBedID: {
    id: "Text-MainPage-SortByBedID",
    defaultMessage: "Sort By Bed ID",
  },
  Text_MainPage_SortByEventTime: {
    id: "Text-MainPage-SortByEventTime",
    defaultMessage: "Sort By Time",
  },
  Text_MainPage_SortByEventType: {
    id: "Text-MainPage-SortByEventType",
    defaultMessage: "Sort By Type",
  },
  Text_MainPage_NoPatient: {
    id: "Text-MainPage-NoPatient",
    defaultMessage: "There is no patient yet.",
  },
  Text_MainPage_NoPatientHint: {
    id: "Text-MainPage-NoPatientHint",
    defaultMessage: "No Patient is added to this care unit.",
  },
  // Main Page-list view
  Text_PatientList_BedNo: {
    id: "Text-PatientList-BedNo",
    defaultMessage: "Bed No.",
  },
  Text_PatientList_Event: {
    id: "Text-PatientList-Event",
    defaultMessage: "Status",
  },
  Text_PatientList_BedsideSettings: {
    id: "Text-PatientList-BedsideSettings",
    defaultMessage: "Bedside Settings",
  },
  Text_PatientList_AlertSettings: {
    id: "Text-PatientList-AlertSettings",
    defaultMessage: "Alert Settings",
  },
  Text_PatientList_Info: {
    id: "Text-PatientList-Info",
    defaultMessage: "Device Info",
  },
  Text_PatientList_BoxID: {
    id: "Text-PatientList-BoxID",
    defaultMessage: "Box ID:",
  },
  Text_PatientList_BoxAudio: {
    id: "Text-PatientList-BoxAudio",
    defaultMessage: "Box Audible",
  },
  Text_PatientList_SensorID: {
    id: "Text-PatientList-SensorID",
    defaultMessage: "Sensor ID:",
  },
  Text_PatientList_UsageTime: {
    id: "Text-PatientList-UsageTime",
    defaultMessage: "Usage Time:",
  },
  Text_PatientList_BoxBrightness: {
    id: "Text-PatientList-BoxBrightness",
    defaultMessage: "Brightness",
  },
  Text_PatientList_BoxVolume: {
    id: "Text-PatientList-BoxVolume",
    defaultMessage: "Volume",
  },
  Text_PatientList_PatientLanguage: {
    id: "Text-PatientList-PatientLanguage",
    defaultMessage: "Patient Language",
  },
  Text_PatientList_SystemLanguage: {
    id: "Text-PatientList-SystemLanguage",
    defaultMessage: "System Language",
  },
  Text_PatientList_CableOrientation: {
    id: "Text-PatientList-CableOrientation",
    defaultMessage: "Cable Orientation",
  },
  Text_PatientList_CableOrientationLeft: {
    id: "Text-PatientList-CableOrientationLeft",
    defaultMessage: "Left",
  },
  Text_PatientList_CableOrientationRight: {
    id: "Text-PatientList-CableOrientationRight",
    defaultMessage: "Right",
  },
  Text_PatientList_Stirring: {
    id: "Text-PatientList-Stirring",
    defaultMessage: "Stirring",
  },
  Text_PatientList_SittingUp: {
    id: "Text-PatientList-SittingUp",
    defaultMessage: "Sitting Up",
  },
  Text_PatientList_Leaving: {
    id: "Text-PatientList-Leaving",
    defaultMessage: "Return / Leaving",
  },
  Text_PatientList_Reposition: {
    id: "Text-PatientList-Reposition",
    defaultMessage: "Reposition",
  },
  Text_PatientList_Wandering: {
    id: "Text-PatientList-Wandering",
    defaultMessage: "Wandering",
  },
  Text_PatientList_VitalSign: {
    id: "Text-PatientList-VitalSign",
    defaultMessage: "Vital Sign",
  },
  Text_PatientList_HR: {
    id: "Text-PatientList-HR",
    defaultMessage: "HR:",
  },
  Text_PatientList_RR: {
    id: "Text-PatientList-RR",
    defaultMessage: "RR:",
  },
  // Patient Setting Value
  Text_Patient_Settings_LED_Off: {
    id: "Text-Patient-Settings-LED-Off",
    defaultMessage: "Close",
  },
  Text_Patient_Settings_LED_Low: {
    id: "Text-Patient-Settings-LED-Low",
    defaultMessage: "Dim",
  },
  Text_Patient_Settings_LED_Mid: {
    id: "Text-Patient-Settings-LED-Mid",
    defaultMessage: "Normal",
  },
  Text_Patient_Settings_LED_High: {
    id: "Text-Patient-Settings-LED-High",
    defaultMessage: "Bright",
  },
  Text_Patient_Settings_Volume_Off: {
    id: "Text-Patient-Settings-Volume-Off",
    defaultMessage: "Off",
  },
  Text_Patient_Settings_Volume_Low: {
    id: "Text-Patient-Settings-Volume-Low",
    defaultMessage: "Low",
  },
  Text_Patient_Settings_Volume_Medium: {
    id: "Text-Patient-Settings-Volume-Medium",
    defaultMessage: "Medium",
  },
  Text_Patient_Settings_Volume_High: {
    id: "Text-Patient-Settings-Volume-High",
    defaultMessage: "High",
  },
  Text_Patient_Settings_Volume_Highest: {
    id: "Text-Patient-Settings-Volume-Highest",
    defaultMessage: "Highest",
  },
  Text_Patient_Settings_PatientLanguage_English: {
    id: "Text-Patient-Settings-PatientLanguage-English",
    defaultMessage: "English",
  },
  Text_Patient_Settings_PatientLanguage_Chinese: {
    id: "Text-Patient-Settings-PatientLanguage-Chinese",
    defaultMessage: "Chinese",
  },
  Text_Patient_Settings_PatientLanguage_Taiwanese: {
    id: "Text-Patient-Settings-PatientLanguage-Taiwanese",
    defaultMessage: "Taiwanese",
  },
  Text_Patient_Settings_PatientLanguage_Japanese: {
    id: "Text-Patient-Settings-PatientLanguage-Japanese",
    defaultMessage: "Japanese",
  },
  Text_Patient_Settings_PatientLanguage_Indonesian: {
    id: "Text-Patient-Settings-PatientLanguage-Indonesian",
    defaultMessage: "Indonesian",
  },
  Text_Patient_Settings_PatientLanguage_Music: {
    id: "Text-Patient-Settings-PatientLanguage-Music",
    defaultMessage: "Music",
  },
  Text_Patient_Settings_SystemLanguage_English: {
    id: "Text-Patient-Settings-SystemLanguage-English",
    defaultMessage: "English",
  },
  Text_Patient_Settings_SystemLanguage_Chinese: {
    id: "Text-Patient-Settings-SystemLanguage-Chinese",
    defaultMessage: "Chinese",
  },
  Text_Patient_Settings_SystemLanguage_Japanese: {
    id: "Text-Patient-Settings-SystemLanguage-Japanese",
    defaultMessage: "Japanese",
  },
  Text_Patient_Settings_SystemLanguage_Indonesian: {
    id: "Text-Patient-Settings-SystemLanguage-Indonesian",
    defaultMessage: "Indonesian",
  },
  Text_Patient_Settings_CableOrientationLeft: {
    id: "Text-Patient-Settings-CableOrientationLeft",
    defaultMessage: "Left",
  },
  Text_Patient_Settings_CableOrientationRight: {
    id: "Text-Patient-Settings-CableOrientationRight",
    defaultMessage: "Right",
  },
  Text_Patient_Settings_Custom: {
    id: "Text-Patient-Settings-Custom",
    defaultMessage: "Custom",
  },

  Text_Unit_Minutes: {
    id: "Text-Unit-Minutes",
    defaultMessage: "Min",
  },
  Text_Unit_Hours: {
    id: "Text-Unit-Hours",
    defaultMessage: "Hours",
  },
  Text_Unit_ShortHour:  { 
    id:  "Text-Unit-ShortHour", 
    defaultMessage: "hr" 
  },
  Text_Unit_Rate: {
    id: "Text-Unit-Rate",
    defaultMessage: "Rate",
  },
  Text_Unit_Bed: {
    id: "Text-Unit-Bed",
    defaultMessage: "Bed",
  },
  // patient Setting/checkin/transfer
  Text_Patient_Settings_PatientAlert: {
    id: "Text-Patient-Settings-PatientAlert",
    defaultMessage: "Patient Alert",
  },
  Text_Patient_Settings_PatientID: {
    id: "Text-Patient-Settings-PatientID",
    defaultMessage: "Patient ID",
  },
  Text_Patient_Settings_InputPatientID: {
    id: "Text-Patient-Settings-InputPatientID",
    defaultMessage: "Enter a patient ID",
  },
  Text_Patient_Settings_BedNumber: {
    id: "Text-Patient-Settings-BedNumber",
    defaultMessage: "Bed No.",
  },
  Text_Patient_Settings_PairedBox: {
    id: "Text-Patient-Settings-PairedBox",
    defaultMessage: "Paired Box",
  },
  Text_Patient_Settings_NewBoxPairing: {
    id: "Text-Patient-Settings-NewBoxPairing",
    defaultMessage: "Bed Pairing",
  },
  Text_Patient_Settings_InputBedNo: {
    id: "Text-Patient-Settings-InputBedNo",
    defaultMessage: "Enter a Bed No.",
  },
  Text_Patient_Settings_BoxSettings: {
    id: "Text-Patient-Settings-BoxSettings",
    defaultMessage: "Box Settings",
  },
  Text_Patient_Settings_PatientLanguage: {
    id: "Text-Patient-Settings-PatientLanguage",
    defaultMessage: "Patient Language",
  },
  Text_Patient_Settings_SystemLanguage: {
    id: "Text-Patient-Settings-SystemLanguage",
    defaultMessage: "System Language",
  },
  Text_Patient_Settings_CableOrientation: {
    id: "Text-Patient-Settings-CableOrientation",
    defaultMessage: "Cable Orientation",
  },
  Text_Patient_Settings_PatientAlertShifts: {
    id: "Text-Patient-Settings-PatientAlertShifts",
    defaultMessage: "Patient Alert By Shifts",
  },
  Text_Patient_Settings_Morning: {
    id: "Text-Patient-Settings-Morning",
    defaultMessage: "Morning",
  },
  Text_Patient_Settings_Night: {
    id: "Text-Patient-Settings-Night",
    defaultMessage: "Night",
  },
  Text_Patient_Settings_Graveyard: {
    id: "Text-Patient-Settings-Graveyard",
    defaultMessage: "Graveyard",
  },
  Text_Patient_Settings_Box: {
    id: "Text-Patient-Settings-Box",
    defaultMessage: "Box",
  },
  Text_Patient_Settings_BoxBrightness: {
    id: "Text-Patient-Settings-BoxBrightness",
    defaultMessage: "Brightness",
  },
  Text_Patient_Settings_BoxVolume: {
    id: "Text-Patient-Settings-BoxVolume",
    defaultMessage: "Volume",
  },
  Text_Patient_Settings_BoxAlertAudio: {
    id: "Text-Patient-Settings-BoxAlertAudio",
    defaultMessage: "Bedside Audible Message",
  },
  Text_Patient_Settings_AlertType: {
    id: "Text-Patient-Settings-AlertType",
    defaultMessage: "Alert Type",
  },
  Text_Patient_Settings_On: {
    id: "Text-Patient-Settings-On",
    defaultMessage: "On",
  },
  Text_Patient_Settings_Off: {
    id: "Text-Patient-Settings-Off",
    defaultMessage: "Off",
  },
  Text_Patient_Settings_Stirring: {
    id: "Text-Patient-Settings-Stirring",
    defaultMessage: "Stirring",
  },
  Text_Patient_Settings_SittingUp: {
    id: "Text-Patient-Settings-SittingUp",
    defaultMessage: "Sitting Up",
  },
  Text_Patient_Settings_Leaving: {
    id: "Text-Patient-Settings-Leaving",
    defaultMessage: "Return / Leaving",
  },
  Text_Patient_Settings_Reposition: {
    id: "Text-Patient-Settings-Reposition",
    defaultMessage: "Reposition",
  },
  Text_Patient_Settings_Wandering: {
    id: "Text-Patient-Settings-Wandering",
    defaultMessage: "Wandering",
  },
  Text_Patient_Settings_Interval: {
    id: "Text-Patient-Settings-Interval",
    defaultMessage: "Interval",
  },
  Text_Patient_Settings_VitalSign: {
    id: "Text-Patient-Settings-VitalSign",
    defaultMessage: "Vital Sign",
  },
  Text_Patient_Settings_HeartRate: {
    id: "Text-Patient-Settings-HeartRate",
    defaultMessage: "Heart Rate",
  },
  Text_Patient_Settings_RespirationRate: {
    id: "Text-Patient-Settings-RespirationRate",
    defaultMessage: "Respiration Rate",
  },
  Text_Patient_Settings_button_Add: {
    id: "Text-Patient-Settings-button-Add",
    defaultMessage: "Add",
  },
  Text_Patient_Settings_button_Apply: {
    id: "Text-Patient-Settings-button-Apply",
    defaultMessage: "Apply",
  },
  Text_Patient_Settings_HintMsg: {
    id: "Text-Patient-Settings-HintMsg",
    defaultMessage: " ",
  },
  Text_Patient_Settings_ConfirmTitle: {
    id: "Text-Patient-Settings-ConfirmTitle",
    defaultMessage: " ",
  },
  Text_Patient_Settings_ConfirmDesc: {
    id: "Text-Patient-Settings-ConfirmDesc",
    defaultMessage: "Please apply new settings before leaving this page.",
  },
  Text_Patient_Settings_button_Discard: {
    id: "Text-Patient-Settings-button-Discard",
    defaultMessage: "Discard changes",
  },
  Text_Patient_Settings_button_OK: {
    id: "Text-Patient-Settings-button-OK",
    defaultMessage: "OK",
  },
  // Patient check-in
  Text_Patient_Checkin_SuccessTitle: {
    id: "Text-Patient-Checkin-SuccessTitle",
    defaultMessage: "Patient added sucessfully",
  },
  Text_Patient_Checkin_SuccessMsg: {
    id: "Text-Patient-Checkin-SuccessMsg",
    defaultMessage: "Patient ID: OOO is sucessfully checked into bed XXX.",
  },
  Text_Patient_Checkin_FailTitle: {
    id: "Text-Patient-Checkin-FailTitle",
    defaultMessage: "Failed to add the patient.",
  },
  Text_Patient_Checkin_FailMsg: {
    id: "Text-Patient-Checkin-FailMsg",
    defaultMessage: "Patient ID: OOO checked into bed XXX failed.",
  },
  // Patient setting
  Text_Patient_Settings_SuccessMsg: {
    id: "Text-Patient-Settings-SuccessMsg",
    defaultMessage: "The settings is sucessfully updated.",
  },
  // Patient Transfer
  Text_Patient_Transfer_DescPairedBed: {
    id: "Text-Patient-Transfer-DescPairedBed",
    defaultMessage: "Transfer to an empty bed with a paired box.",
  },
  Text_Patient_Transfer_DescChangeBox: {
    id: "Text-Patient-Transfer-DescChangeBox",
    defaultMessage: "On the same bed XXX",
  },
  Text_Patient_Transfer_DescUnpairedBed: {
    id: "Text-Patient-Transfer-DescUnpairedBed",
    defaultMessage: "Continue using Box XXX",
  },
  Text_Patient_Transfer_MsgPairedBed: {
    id: "Text-Patient-Transfer-MsgPairedBed",
    defaultMessage: "Transfer to an empty bed with a paired box.",
  },
  Text_Patient_Transfer_MsgChangeBox: {
    id: "Text-Patient-Transfer-MsgChangeBox",
    defaultMessage: "Continue using Box XXX but change to another bed.",
  },
  Text_Patient_Transfer_MsgUnpairedBed: {
    id: "Text-Patient-Transfer-MsgUnpairedBed",
    defaultMessage: "On the same bed XXX, but changed to another box.",
  },
  Text_Patient_Transfer_ButtonPairedBed: {
    id: "Text-Patient-Transfer-ButtonPairedBed",
    defaultMessage: "Choose an empty bed",
  },
  Text_Patient_Transfer_ButtonUnpairedBed: {
    id: "Text-Patient-Transfer-ButtonUnpairedBed",
    defaultMessage: "Change a Bed No.",
  },
  Text_Patient_Transfer_ButtonChangeBox: {
    id: "Text-Patient-Transfer-ButtonChangeBox",
    defaultMessage: "Change a Box ID",
  },
  Text_Patient_Transfer_SuccessMsg: {
    id: "Text-Patient-Transfer-SuccessMsg",
    defaultMessage: "The patient is sucessfully transferred.",
  },
  // Patient check-out
  Text_Patient_CheckOut_Message: {
    id: "Text-Patient-CheckOut-Message",
    defaultMessage:
      "Once you check-out the patient, all information will be deleted. Are you sure you want to check-out this patient?",
  },
  Text_Patient_CheckOut_SuccessMsg: {
    id: "Text-Patient-CheckOut-SuccessMsg",
    defaultMessage: "Patient logout success.",
  },
  Text_Patient_CheckOut_Button: {
    id: "Text-Patient-CheckOut-Button",
    defaultMessage: "Yes, check-out",
  },
  // Common
  Text_Button_Ok: {
    id: "Text-Button-Ok",
    defaultMessage: "Confirm",
  },
  Text_Button_Cancel: {
    id: "Text-Button-Cancel",
    defaultMessage: "Cancel",
  },
  Text_Button_Send: {
    id: "Text-Button-Send",
    defaultMessage: "Send",
  },
  Text_Button_Add: {
    id: "Text-Button-Add",
    defaultMessage: "Add",
  },
  Text_Button_Edit: {
    id: "Text-Button-Edit",
    defaultMessage: "Edit",
  },
  Text_Button_Updated: {
    id: "Text-Button-Updated",
    defaultMessage: "Updated",
  },
  Text_Button_Detail: {
    id: "Text-Button-Detail",
    defaultMessage: "Detail >>",
  },
  Text_Common_Action: {
    id: "Text-Common-Action",
    defaultMessage: "Action",
  },
  Text_Common_Success: {
    id: "Text-Common-Success",
    defaultMessage: "Success",
  },
  Text_Common_Fail: {
    id: "Text-Common-Fail",
    defaultMessage: "Fail",
  },
  Text_Common_SelectAll: {
    id: "Text-Common-SelectAll",
    defaultMessage: "Select All",
  },
  // patient Detail Page
  Text_PatientDetail_VitalBlock_VITAL:  { 
      id:  "Text-PatientDetail-VitalBlock-VITAL", 
      defaultMessage: "Vital Sign" 
  },
  Text_PatientDetail_VitalBlock_Respiration_Abnormal:  { 
      id:  "Text-PatientDetail-VitalBlock-Respiration-Abnormal", 
      defaultMessage: "RR abnormal" 
  },
  Text_PatientDetail_VitalBlock_HeartRate_Abnormal:  { 
      id:  "Text-PatientDetail-VitalBlock-HeartRate-Abnormal", 
      defaultMessage: "HR abnormal" 
    },
  Text_PatientDetail_VitalBlock_RespirationAndHeartRate_Abnormal:  { 
      id:  "Text-PatientDetail-VitalBlock-RespirationAndHeartRate-Abnormal", 
      defaultMessage: "HR&RR abnormal" 
  },
  Text_PatientDetail_VitalBlock_No_Abnormal:  { 
      id:  "Text-PatientDetail-VitalBlock-No-Abnormal", 
      defaultMessage: "No abnormality" 
  },
  Text_PatientDetail_VitalBlock_Average:  { 
      id:  "Text-PatientDetail-VitalBlock-Average", 
      defaultMessage: "Average" 
   },
  Text_PatientDetail_VitalBlock_Summary:  { 
      id:  "Text-PatientDetail-VitalBlock-Summary", 
      defaultMessage: "Summary" 
  },
  Text_PatientDetail_VitalBlock_Alert:  { 
      id:  "Text-PatientDetail-VitalBlock-Alert", 
      defaultMessage: "Alert" 
   },
    Text_PatientDetail_VitalBlock_Lowest:  { 
      id:  "Text-PatientDetail-VitalBlock-Lowest", 
      defaultMessage: "Lowest" 
      },
    Text_PatientDetail_VitalBlock_LowerQuartile:  { 
      id:  "Text-PatientDetail-VitalBlock-LowerQuartile", 
      defaultMessage: "LowerQuartile" 
      },
    Text_PatientDetail_VitalBlock_Median:  { 
      id:  "Text-PatientDetail-VitalBlock-Median", 
      defaultMessage: "Median" 
      },
    Text_PatientDetail_VitalBlock_UpperQuartile:  { 
      id:  "Text-PatientDetail-VitalBlock-UpperQuartile", 
      defaultMessage: "UpperQuartile" 
      },
    Text_PatientDetail_VitalBlock_Highest:  { 
      id:  "Text-PatientDetail-VitalBlock-Highest", 
      defaultMessage: "Highest" 
      },
    Text_PatientDetail_VitalBlock_Amount:  { 
      id:  "Text-PatientDetail-VitalBlock-Amount", 
      defaultMessage: "Amount" 
      },
    Text_PatientDetail_VitalBlock_HeartRate:  { 
      id:  "Text-PatientDetail-VitalBlock-HeartRate", 
      defaultMessage: "HeartRate" 
      },
    Text_PatientDetail_VitalBlock_RespirationRate:  { 
      id:  "Text-PatientDetail-VitalBlock-RespirationRate", 
      defaultMessage: "RespirationRate" 
      },
  Text_PatientDetail_EventBlock_Header_EVENT: {
    id: "Text-PatientDetail-EventBlock-Header-EVENT",
    defaultMessage: "Event Record",
  },
  Text_PatientDetail_EventBlock_Event_Sittingup: {
    id: "Text-PatientDetail-EventBlock-Event-Sittingup",
    defaultMessage: "Sitting up",
  },
  Text_PatientDetail_EventBlock_Event_Leaving: {
    id: "Text-PatientDetail-EventBlock-Event-Leaving",
    defaultMessage: "Leaving",
  },
  Text_PatientDetail_EventBlock_Event_OutofBed: {
    id: "Text-PatientDetail-EventBlock-Event-OutofBed",
    defaultMessage: "Out of Bed",
  },
  Text_PatientDetail_EventBlock_Event_Return: {
    id: "Text-PatientDetail-EventBlock-Event-Return",
    defaultMessage: "Return",
  },
  Text_PatientDetail_EventBlock_Event_Wandering: {
    id: "Text-PatientDetail-EventBlock-Event-Wandering",
    defaultMessage: "Wandering",
  },
  Text_PatientDetail_EventBlock_Event_NurseModeOn: {
    id: "Text-PatientDetail-EventBlock-Event-NurseModeOn",
    defaultMessage: "Nurse mode",
  },
  Text_PatientDetail_EventBlock_Event_NurseResponse: {
    id: "Text-PatientDetail-EventBlock-Event-NurseResponse",
    defaultMessage: "Nurse Response",
  },
  Text_PatientDetail_EventBlock_Event_Reposition: {
    id: "Text-PatientDetail-EventBlock-Event-Reposition",
    defaultMessage: "Reposition",
  },
  Text_PatientDetail_EventBlock_Event_RepositionReset: {
    id: "Text-PatientDetail-EventBlock-Event-RepositionReset",
    defaultMessage: "Reposition Reset",
  },
  Text_PatientDetail_EventBlock_Event_Immobile: {
    id: "Text-PatientDetail-EventBlock-Event-Immobile",
    defaultMessage: "Immobile",
  },

  Text_PatientDetail_PressureBlock_PRESSURE: {
    id: "Text-PatientDetail-PressureBlock-PRESSURE",
    defaultMessage: "Pressure Record",
  },
  Text_PatientDetail_PressureBlock_Unit_PressureDuration: {
    id: "Text-PatientDetail-PressureBlock-Unit-PressureDuration",
    defaultMessage: "Pressure Duration",
  },
  Text_PatientDetail_PressureBlock_Unit_PressureLevel: {
    id: "Text-PatientDetail-PressureBlock-Unit-PressureLevel",
    defaultMessage: "Pressure Level",
  },
  Text_PatientDetail_PressureBlock_PressureLevel: {
    id: "Text-PatientDetail-PressureBlock-PressureLevel",
    defaultMessage: "Pressure Level",
  },
  Text_PatientDetail_PressureBlock_PressureDuration: {
    id: "Text-PatientDetail-PressureBlock-PressureDuration",
    defaultMessage: "Pressure Duration",
  },
  Text_PatientDetail_DayRecord: {
    id: "Text-PatientDetail-DayRecord",
    defaultMessage: "Daily Record",
  },
  Text_PatientDetail_Past5DayRecord: {
    id: "Text-PatientDetail-Past5DayRecord",
    defaultMessage: "Past 5 Days Activity Record",
  },
  Text_PatientDetail_ActivityRecord: {
    id: "Text-PatientDetail-ActivityRecord",
    defaultMessage: "Activity Record",
  },
  Text_PatientDetail_ActivitySummary: {
    id: "Text-PatientDetail-ActivitySummary",
    defaultMessage: "Activity Summary",
  },
  Text_PatientDetail_OutOfBed: {
    id: "Text-PatientDetail-OutOfBed",
    defaultMessage: "Out of Bed",
  },
  Text_PatientDetail_HighActivity: {
    id: "Text-PatientDetail-HighActivity",
    defaultMessage: "High Activity",
  },
  Text_PatientDetail_LowActivity: {
    id: "Text-PatientDetail-LowActivity",
    defaultMessage: "Low Activity",
  },
  Text_PatientDetail_Monday: {
    id: "Text-PatientDetail-Monday",
    defaultMessage: "Mon",
  },
  Text_PatientDetail_Tuesday: {
    id: "Text-PatientDetail-Tuesday",
    defaultMessage: "Tue",
  },
  Text_PatientDetail_Wednesday: {
    id: "Text-PatientDetail-Wednesday",
    defaultMessage: "Wed",
  },
  Text_PatientDetail_Thursday: {
    id: "Text-PatientDetail-Thursday",
    defaultMessage: "Thu",
  },
  Text_PatientDetail_Friday: {
    id: "Text-PatientDetail-Friday",
    defaultMessage: "Fri",
  },
  Text_PatientDetail_Saturday: {
    id: "Text-PatientDetail-Saturday",
    defaultMessage: "Sat",
  },
  Text_PatientDetail_Sunday: {
    id: "Text-PatientDetail-Sunday",
    defaultMessage: "Sun",
  },

  // UserSetting
  Text_UserSetting_CurrentPassword: {
    id: "Text-UserSetting-CurrentPassword",
    defaultMessage: "Current password",
  },
  Text_UserSetting_EnterCurrentPassword: {
    id: "Text-UserSetting-EnterCurrentPassword",
    defaultMessage: "Enter your current password",
  },
  Text_UserSetting_NewPWD: {
    id: "Text-UserSetting-NewPWD",
    defaultMessage: "New Password",
  },
  Text_UserSetting_EnterNewPWD: {
    id: "Text-UserSetting-EnterNewPWD",
    defaultMessage: "Enter a new password",
  },
  Text_UserSetting_ConfirmNewPWD: {
    id: "Text-UserSetting-ConfirmNewPWD",
    defaultMessage: "Confirm Password",
  },
  Text_UserSetting_ReEnterConfirmNewPWD: {
    id: "Text-UserSetting-ReEnterConfirmNewPWD",
    defaultMessage: "Re-enter your new password",
  },
  // Box Wi-Fi
  Text_BoxWiFi_Tab_Configurations: {
    id: "Text-BoxWiFi-Tab-Configurations",
    defaultMessage: "Configurations",
  },
  Text_BoxWiFi_Tab_WiFiProfile: {
    id: "Text-BoxWiFi-Tab-WiFiProfile",
    defaultMessage: "WiFi Profile",
  },
  Text_BoxWiFi_BoxId: {
    id: "Text-BoxWiFi-BoxId",
    defaultMessage: "Box ID",
  },
  Text_BoxWiFi_Status: {
    id: "Text-BoxWiFi-Status",
    defaultMessage: "Status",
  },
  Text_BoxWiFi_WiFiProfile: {
    id: "Text-BoxWiFi-WiFiProfile",
    defaultMessage: "WiFi Profile",
  },
  Text_BoxWiFi_LastUpdatedTime: {
    id: "Text-BoxWiFi-LastUpdatedTime",
    defaultMessage: "Last Updated",
  },
  Text_BoxWiFi_NetworkName: {
    id: "Text-BoxWiFi-NetworkName",
    defaultMessage: "Network Name",
  },
  Text_BoxWiFi_SSID: {
    id: "Text-BoxWiFi-SSID",
    defaultMessage: "SSID",
  },
  Text_BoxWiFi_NetworkInfo: {
    id: "Text-BoxWiFi-NetworkInfo",
    defaultMessage: "Network Info",
  },
  Text_BoxWiFi_Version: {
    id: "Text-BoxWiFi-Version",
    defaultMessage: "Version",
  },
  Text_BoxWiFi_Processing: {
    id: "Text-BoxWiFi-Processing",
    defaultMessage: "Processing",
  },
  Text_BoxWiFi_Succeed: {
    id: "Text-BoxWiFi-Succeed",
    defaultMessage: "Succeed",
  },
  Text_BoxWiFi_Button_AddaPreparation: {
    id: "Text-BoxWiFi-Button-AddaPreparation",
    defaultMessage: "Add a Preparation",
  },
  Text_BoxWiFi_AddaPreparation_NoBoxMsg: {
    id: "Text-BoxWiFi-AddaPreparation-NoBoxMsg",
    defaultMessage: "Please select the box first!",
  },
  Text_BoxWiFi_Title_AddaPreparation: {
    id: "Text-BoxWiFi-Title-AddaPreparation",
    defaultMessage: "Add a Preparation",
  },
  Text_BoxWiFi_AddaPreparation_Info: {
    id: "Text-BoxWiFi-AddaPreparation-Info",
    defaultMessage: "Please select the Wi-Fi for the following boxes",
  },
  Text_BoxWiFi_SelectedBoxIDs: {
    id: "Text-BoxWiFi-SelectedBoxIDs",
    defaultMessage: "Selected Boxes ID",
  },
  Text_BoxWiFi_Button_Prepare: {
    id: "Text-BoxWiFi-Button-Prepare",
    defaultMessage: "Prepare",
  },
  Text_BoxWiFi_Button_AddaProfile: {
    id: "Text-BoxWiFi-Button-AddaProfile",
    defaultMessage: "Add a Profile",
  },
  Text_BoxWiFi_Title_AddaProfile: {
    id: "Text-BoxWiFi-Title-AddaProfile",
    defaultMessage: "Add a Profile",
  },
  Text_BoxWiFi_Title_EditProfile: {
    id: "Text-BoxWiFi-Title-EditProfile",
    defaultMessage: "Edit Profile",
  },
  // Box Pairing
  Text_BoxPairing_BoxId: {
    id: "Text-BoxPairing-BoxId",
    defaultMessage: "Box ID",
  },
  Text_BoxPairing_BoxId2: {
    id: "Text-BoxPairing-BoxId2",
    defaultMessage: "Box ID",
  },
  Text_BoxPairing_BedNo: {
    id: "Text-BoxPairing-BedNo",
    defaultMessage: "Bed No.",
  },
  Text_BoxPairing_SensorInfo: {
    id: "Text-BoxPairing-SensorInfo",
    defaultMessage: "Sensor Info",
  },
  Text_BoxPairing_NoPairing: {
    id: "Text-BoxPairing-NoPairing",
    defaultMessage: "No Pairing",
  },
  Text_BoxPairing_SensorID: {
    id: "Text-BoxPairing-SensorID",
    defaultMessage: "Sensor ID",
  },
  Text_BoxPairing_UsageTime: {
    id: "Text-BoxPairing-UsageTime",
    defaultMessage: "Usage Time",
  },
  Text_BoxPairing_Button_BedPairing: {
    id: "Text-BoxPairing-Button-BedPairing",
    defaultMessage: "Bed Pairing",
  },
  Text_BoxPairing_Button_Remove: {
    id: "Text-BoxPairing-Button-Remove",
    defaultMessage: "Remove",
  },
  Text_BoxPairing_Button_AddNewBoxes: {
    id: "Text-BoxPairing-Button-AddNewBoxes",
    defaultMessage: "Add New Boxes",
  },
  Text_BoxPairing_Title_AddNewBoxes: {
    id: "Text-BoxPairing-Title-AddNewBoxes",
    defaultMessage: "Add New Boxes",
  },
  Text_BoxPairing_AddNewBoxes_Info: {
    id: "Text-BoxPairing-AddNewBoxes-Info",
    defaultMessage: "Select the boxes to be added to the Care Unit.",
  },
  Text_BoxPairing_CareUnit: {
    id: "Text-BoxPairing-CareUnit",
    defaultMessage: "Care Unit",
  },
  Text_BoxPairing_Title_BedPairing: {
    id: "Text-BoxPairing-Title-BedPairing",
    defaultMessage: "Bed Pairing",
  },
  Text_BoxPairing_Button_ClearPairing: {
    id: "Text-BoxPairing-Button-ClearPairing",
    defaultMessage: "Clear Pairing",
  },
  Text_BoxPairing_Button_UpdatePairing: {
    id: "Text-BoxPairing-Button-UpdatePairing",
    defaultMessage: "Update Pairing",
  },
  Text_BoxPairing_Title_Detail: {
    id: "Text-BoxPairing-Title-Detail",
    defaultMessage: "Control Box Details",
  },
  Text_BoxPairing_HardwareInformation: {
    id: "Text-BoxPairing-HardwareInformation",
    defaultMessage: "Hardware Information",
  },
  Text_BoxPairing_ControlBox: {
    id: "Text-BoxPairing-ControlBox",
    defaultMessage: "Control Box",
  },
  Text_BoxPairing_SerialNumber: {
    id: "Text-BoxPairing-SerialNumber",
    defaultMessage: "Serial Number",
  },
  Text_BoxPairing_Version: {
    id: "Text-BoxPairing-Version",
    defaultMessage: "Version",
  },
  Text_BoxPairing_IP: {
    id: "Text-BoxPairing-IP",
    defaultMessage: "IP",
  },
  Text_BoxPairing_Sensor: {
    id: "Text-BoxPairing-Sensor",
    defaultMessage: "Sensor",
  },
  Text_BoxPairing_Title_Remove: {
    id: "Text-BoxPairing-Title-Remove",
    defaultMessage: "Remove Control Box",
  },
  Text_BoxPairing_Remove_Info: {
    id: "Text-BoxPairing-Remove-Info",
    defaultMessage: "Are you sure you want to remove the Control Box?",
  },
  Text_BoxPairing_Remove_SuccessMsg: {
    id: "Text-BoxPairing-Remove-SuccessMsg",
    defaultMessage: "Control Box removed successfully",
  },
  Text_BoxPairing_ClearPairing_SuccessMsg: {
    id: "Text-BoxPairing-ClearPairing-SuccessMsg",
    defaultMessage: "Clear Pairing successfully",
  },
  Text_BoxPairing_UpdatePairing_SuccessMsg: {
    id: "Text-BoxPairing-UpdatePairing-SuccessMsg",
    defaultMessage: "Update Pairing successfully",
  },
  Text_BoxPairing_AddNewBoxes_SuccessMsg: {
    id: "Text-BoxPairing-AddNewBoxes-SuccessMsg",
    defaultMessage: "Added successfully",
  },
  Text_BoxPairing_UpdatePairing_InputHint: {
    id: "Text-BoxPairing-UpdatePairing-InputHint",
    defaultMessage: "Only English letters, numbers, '.', '-', '_' are allowed.",
  },
  Text_BoxDispatch_AddNewBoxes_Info: {
    id: "Text-BoxDispatch-AddNewBoxes-Info",
    defaultMessage: "Select the boxes to be added to [{orgName}].",
  },

  // User Management
  Text_UserRoleID_0: {
    id: "Text-UserRoleID-0",
    defaultMessage: "Guest",
  },
  Text_UserRoleID_1: {
    id: "Text-UserRoleID-1",
    defaultMessage: "System Administrator",
  },
  Text_UserRoleID_2: {
    id: "Text-UserRoleID-2",
    defaultMessage: "Manager",
  },
  Text_UserRoleID_3: {
    id: "Text-UserRoleID-3",
    defaultMessage: "Nurse",
  },
  Text_UserManagement_Account: {
    id: "Text-UserManagement-Account",
    defaultMessage: "User ID",
  },
  Text_UserManagement_EnterAccount: {
    id: "Text-UserManagement-EnterAccount",
    defaultMessage: "Enter a ID",
  },
  Text_UserManagement_Name: {
    id: "Text-UserManagement-Name",
    defaultMessage: "Name",
  },
  Text_UserManagement_EnterName: {
    id: "Text-UserManagement-EnterName",
    defaultMessage: "Enter a name",
  },
  Text_UserManagement_Role: {
    id: "Text-UserManagement-Role",
    defaultMessage: "Role",
  },
  Text_UserManagement_Status: {
    id: "Text-UserManagement-Status",
    defaultMessage: "Status",
  },
  Text_UserManagement_StatusEnabled: {
    id: "Text-UserManagement-StatusEnabled",
    defaultMessage: "Enabled",
  },
  Text_UserManagement_StatusDisable: {
    id: "Text-UserManagement-StatusDisable",
    defaultMessage: "Disable",
  },
  Text_UserManagement_History: {
    id: "Text-UserManagement-History",
    defaultMessage: "History",
  },
  Text_UserManagement_LastUpdatedTime: {
    id: "Text-UserManagement-LastUpdatedTime",
    defaultMessage: "Last Updated Time",
  },
  Text_UserManagement_CreationDate: {
    id: "Text-UserManagement-CreationDate",
    defaultMessage: "Creation Date",
  },
  Text_UserManagement_CareUnit: {
    id: "Text-UserManagement-CareUnit",
    defaultMessage: "Care Unit",
  },
  Text_UserManagement_Password: {
    id: "Text-UserManagement-Password",
    defaultMessage: "Password",
  },
  Text_UserManagement_EnterPassword: {
    id: "Text-UserManagement-EnterPassword",
    defaultMessage: "Enter a password",
  },
  Text_UserManagement_ConfirmPassword: {
    id: "Text-UserManagement-ConfirmPassword",
    defaultMessage: "Confirm password",
  },
  Text_UserManagement_EnterConfirmPassword: {
    id: "Text-UserManagement-EnterConfirmPassword",
    defaultMessage: "Re-enter the password",
  },
  Text_UserManagement_TemporaryPassword_Info: {
    id: "Text-UserManagement-TemporaryPassword-Info",
    defaultMessage:
      "The user will need to change their password immediately after the next login.",
  },
  Text_UserManagement_DoNotActivateAccount: {
    id: "Text-UserManagement-DoNotActivateAccount",
    defaultMessage: "Do not activate this account yet.",
  },
  Text_UserManagement_AddAccountSuccess: {
    id: "Text-UserManagement-AddAccountSuccess",
    defaultMessage: "Add user success.",
  },
  Text_UserManagement_EditUserSucess: {
    id: "Text-UserManagement-EditUserSucess",
    defaultMessage: "Edit user success.",
  },
  Text_UserManagement_ChangePasswordSucess: {
    id: "Text-UserManagement-ChangePasswordSucess",
    defaultMessage: "Change password success.",
  },
  Text_UserManagement_Button_AddUser: {
    id: "Text-UserManagement-Button-AddUser",
    defaultMessage: "Add User",
  },
  Text_UserManagement_Button_EditUser: {
    id: "Text-UserManagement-Button-EditUser",
    defaultMessage: "Edit",
  },
  Text_UserManagement_Button_ChangePassword: {
    id: "Text-UserManagement-Button-ChangePassword",
    defaultMessage: "Change Password",
  },
  Text_UserManagement_Title_AddUser: {
    id: "Text-UserManagement-Title-AddUser",
    defaultMessage: "Add User",
  },
  Text_UserManagement_Title_EditUser: {
    id: "Text-UserManagement-Title-EditUser",
    defaultMessage: "Edit User",
  },
  Text_UserManagement_Title_TemporaryPassword: {
    id: "Text-UserManagement-Title-TemporaryPassword",
    defaultMessage: "Set a Temporary Password",
  },
  Text_UserManagement_Table_SortDesc: {
    id: "Text-UserManagement-Table-SortDesc",
    defaultMessage: "Click to sort descending",
  },
  Text_UserManagement_Table_SortAsc: {
    id: "Text-UserManagement-Table-SortAsc",
    defaultMessage: "Click to sort ascending",
  },
  Text_UserManagement_Table_SortCancel: {
    id: "Text-UserManagement-Table-SortCancel",
    defaultMessage: "Click to cancel sorting",
  },
  // About
  Text_About_Product: {
    id: "Text-About-Product",
    defaultMessage: "Predictive Patient Monitoring",
  },
  Text_About_Company: {
    id: "Text-About-Company",
    defaultMessage: "© Cognito Health Inc. All Rights Reserved.",
  },
  Text_About_Context: {
    id: "Text-About-Context",
    defaultMessage:
      "The Cognito 3.0 is a contact-free, predictive patient monitoring system comprising of a sensor pad, control box, Cognito dashboard and mobile app. Cognito 3.0 provides bed exit and reposition related safety notifications for fall prevention and reposition assistance for healthcare staff and professionals. Additional information, such as activity record, pressure record, alert event record, are provided to improve clinical efficiency for administrative purposes only and are not intended as a substitute for medical diagnosis or treatment..\n\nLocalization languages:\nEnglish, Japanese, Chinese (Traditional)",
  },
  Text_About_OfficialWebsite: {
    id: "Text-About-OfficialWebsite",
    defaultMessage: "Official Website",
  },
  Text_About_OfficialWebsite_URL: {
    id: "Text-About-OfficialWebsite-URL",
    defaultMessage: "https://www.cognitohealth.com.tw/",
  },
  Text_About_SystemConfigurationTitle: {
    id: "Text-About-SystemConfigurationTitle",
    defaultMessage: "Mobile App Requirement:",
  },
  Text_About_SystemConfiguration: {
    id: "Text-About-SystemConfiguration",
    defaultMessage:
      "\n        Android Mobile App |Android 10 or above;\n        iOS Mobile App |iOS 17 or above\n  ",
  },
  Text_About_Overview: {
    id: "Text-About-Overview",
    defaultMessage: "Overview",
  },
  Text_Legal_Title: {
    id: "Text-Legal-Title",
    defaultMessage: "Legal Notices",
  },
  Text_Legal_Message: {
    id: "Text-Legal-Message",
    defaultMessage:
      "Cognito Health was founded in 2012 and is dedicated to improving health and healthcare by increasing value for patients and healthcare systems.",
  },
  Text_Legal_privacypolicy: {
    id: "Text-Legal-privacypolicy",
    defaultMessage: "Privacy Policy",
  },
  Text_Legal_privacypolicy_URL: {
    id: "Text-Legal-privacypolicy-URL",
    defaultMessage: "https://www.cognitohealth.com/privacy-policy",
  },
  // Error Msg
  Text_ErrorMessage_E001: {
    id: "Text-ErrorMessage-E001",
    defaultMessage: "This column cannot be empty",
  },
  Text_ErrorMessage_E002: {
    id: "Text-ErrorMessage-E002",
    defaultMessage: "Only English letters, numbers, '.', '-', '_' are allowed.",
  },
  Text_ErrorMessage_E003: {
    id: "Text-ErrorMessage-E003",
    defaultMessage: "Input length cannot be less than 6 characters",
  },
  Text_ErrorMessage_E004: {
    id: "Text-ErrorMessage-E004",
    defaultMessage: "Input length cannot be less than 8 characters",
  },
  Text_ErrorMessage_E005: {
    id: "Text-ErrorMessage-E005",
    defaultMessage: "The passwords do not match",
  },
  Text_ErrorMessage_E006: {
    id: "Text-ErrorMessage-E006",
    defaultMessage: "New password cannot be empty",
  },
  Text_ErrorMessage_E007: {
    id: "Text-ErrorMessage-E007",
    defaultMessage:
      "New password may only contain English letters, numbers, '.'",
  },
  Text_ErrorMessage_E008: {
    id: "Text-ErrorMessage-E008",
    defaultMessage: "Password cannot be empty",
  },
  Text_ErrorMessage_E009: {
    id: "Text-ErrorMessage-E009",
    defaultMessage: "Account cannot be empty",
  },
  Text_ErrorMessage_E010: {
    id: "Text-ErrorMessage-E010",
    defaultMessage: "Datetime column error",
  },
  Text_ErrorMessage_E011: {
    id: "Text-ErrorMessage-E011",
    defaultMessage: "Password reset failed.",
  },
  Text_ErrorMessage_E012: {
    id: "Text-ErrorMessage-E012",
    defaultMessage: "Only letters and numbers are allowed.",
  },
  Text_ErrorMessage_E013: {
    id: "Text-ErrorMessage-E013",
    defaultMessage: "The maximum length is 9 characters.",
  },
  Text_ErrorMessage_E014: {
    id: "Text-ErrorMessage-E014",
    defaultMessage: "This field is required.",
  },
  Text_ErrorMessage_E015: {
    id: "Text-ErrorMessage-E015",
    defaultMessage: "Please resolve validation errors and retry.",
  },
  Text_ErrorMessage_E016: {
    id: "Text-ErrorMessage-E016",
    defaultMessage: "The maximum length is 20 characters.",
  },
  Text_ErrorMessage_E017: {
    id: "Text-ErrorMessage-E017",
    defaultMessage: "Not Found",
  },
  Text_ErrorMessage_E018: {
    id: "Text-ErrorMessage-E018",
    defaultMessage: "Sorry, the page you visited does not exist.",
  },
  Text_ErrorMessage_E019: {
    id: "Text-ErrorMessage-E019",
    defaultMessage:
      "A higher permission-level is required to check-in a patient.",
  },
  Text_ErrorMessage_E020: {
    id: "Text-ErrorMessage-E020",
    defaultMessage: "Session timeout. Please reload the page and try again.",
  },
  Text_ErrorMessage_E021: {
    id: "Text-ErrorMessage-E021",
    defaultMessage:
      "A higher permission-level is required to access patient detail page.",
  },
  Text_ErrorMessage_E022: {
    id: "Text-ErrorMessage-E022",
    defaultMessage: "The maximum length is 7 characters.",
  },
  Text_ErrorMessage: {
    id: "Text-ErrorMessage",
    defaultMessage: "An Error Occurred",
  },

  Text_AuthErrorMessage_11: {
    id: "Text-AuthErrorMessage-11",
    defaultMessage: "This account or email already exists.",
  },
  Text_AuthErrorMessage_12: {
    id: "Text-AuthErrorMessage-12",
    defaultMessage: "User ID is invalid.",
  },

  Text_System_ErrorMessage_ServiceDiscovery: {
    id: "Text-System-ErrorMessage-ServiceDiscovery",
    defaultMessage: "An error occurred, please reload the page.",
  },
  Text_SystemError_Title: {
    id: "Text-SystemError-Title",
    defaultMessage: "System Abnormality Detected",
  },
  Text_SystemError_MessageTitle: {
    id: "Text-SystemError-MessageTitle",
    defaultMessage: "The system detects the following abnormality at Bed XXX：",
  },
  Text_SystemError_MessageContext: {
    id: "Text-SystemError-MessageContext",
    defaultMessage:
      "Please refer to the user manual for more information on troubleshooting.",
  },

  Text_Button_Reload: {
    id: "Text-Button-Reload",
    defaultMessage: "Reload",
  },
  Text_Button_Retry: {
    id: "Text-Button-Retry",
    defaultMessage: "Retry",
  },
  Text_System_ErrorMessage_ConnectionTitle: {
    id: "Text-System-ErrorMessage-ConnectionTitle",
    defaultMessage: "System Disconnected",
  },
  Text_System_ErrorMessage_ConnectionRetry: {
    id: "Text-System-ErrorMessage-ConnectionRetry",
    defaultMessage: "System connection lost. Please reconnect to the internet.",
  },

  Text_ErrorMessage_1000: {
    id: "Text-ErrorMessage-1000",
    defaultMessage: "Wrong Account or Wrong Password.",
  },
  Text_ErrorMessage_1001: {
    id: "Text-ErrorMessage-1001",
    defaultMessage: "The patient is not in the system.",
  },
  Text_ErrorMessage_1002: {
    id: "Text-ErrorMessage-1002",
    defaultMessage: "The patient is not checked in the system.",
  },
  Text_ErrorMessage_1003: {
    id: "Text-ErrorMessage-1003",
    defaultMessage: "Patient has been checked in.",
  },
  Text_ErrorMessage_1004: {
    id: "Text-ErrorMessage-1004",
    defaultMessage:
      "The old and new bed number and Box Id information remains unchanged, no need to do patient transfer",
  },
  Text_ErrorMessage_10041: {
    id: "Text-ErrorMessage-10041",
    defaultMessage: "The bed is in use.",
  },
  Text_ErrorMessage_10042: {
    id: "Text-ErrorMessage-10042",
    defaultMessage:
      "Cannot modify the Control Box during the Patient Check-in.",
  },
  Text_ErrorMessage_1005: {
    id: "Text-ErrorMessage-1005",
    defaultMessage: "The box is not in the system.",
  },
  Text_ErrorMessage_1006: {
    id: "Text-ErrorMessage-1006",
    defaultMessage: "The account is not in the system.",
  },
  Text_ErrorMessage_1007: {
    id: "Text-ErrorMessage-1007",
    defaultMessage: "Old password is incorrect, please re-enter the password.",
  },
  Text_ErrorMessage_1008: {
    id: "Text-ErrorMessage-1008",
    defaultMessage:
      "The bed is already paired with other Control Box. Please re-enter another bed number.",
  },
  Text_ErrorMessage_1100: {
    id: "Text-ErrorMessage-1100",
    defaultMessage: "The data already exists",
  },
  Text_ErrorMessage_2001: {
    id: "Text-ErrorMessage-2001",
    defaultMessage: "An error occurred, please reload the page.",
  },
});
